
<div class="project-widget-container" :tabindex="tabindex" @click="handleClick($event)">
	<div class="project-widget-header">
		<!-- @slot Used to display project widget header -->
		<slot name="project-icon" />
		<div class="project-header-meta">
			<h1 class="fc-dark text-ellipsis">
				{{ title }}
			</h1>
			<h6 v-if="subTitle" class="fw-normal fc-light text-ellipsis">
				{{ subTitle }}
			</h6>
		</div>
		<div class="project-widget-settings-icon">
			<Icon name="settings" type="filled" size="small" @click="settings($event)" />
		</div>
	</div>
	<div class="project-widget-body">
		<!-- @slot Used to display project widget key-value type data -->
		<slot />
	</div>
	<div class="project-widget-footer">
		<div class="project-footer-meta">
			<div class="project-footer-label fc-light">
				<h6 class="fw-normal fc-light upper-case text-ellipsis">
					{{ footerLabel }}
				</h6>
			</div>
			<div class="project-footer-toggle">
				<Icon
					:name="'menu-down'"
					type="filled"
					size="small"
					:rotate="innerFooterExpanded ? 0 : 180"
					@click="toggleFooter($event)"
				/>
			</div>
		</div>
		<div class="project-env-grid" :compact="!innerFooterExpanded">
			<!-- @slot Used to display environments -->
			<slot name="footer" />
		</div>
	</div>
</div>
